export default __webpack_public_path__ + "static/media/bacqueville15.aa02755a.jpg";